import { useQuery } from 'react-query';

import { getIntegratedScheduleVersion as queryFn } from 'api/endPoints/getIntegratedScheduleVersion';

export const useQueryGetIntegratedScheduleVersion = (params: { fileMetaDataId: number }) => {
    return useQuery<unknown, QueryError>({
        queryKey: ['getIntegratedScheduleVersion', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.fileMetaDataId),
    });
};
